import { wireIntake } from './y3dm-intake-client.js';
function initialize(scope) {
  const roots = [...scope.querySelectorAll('[data-y3dm-design]')];
  if (scope.matches?.('[data-y3dm-design]')) roots.unshift(scope);
  roots.forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(document.getElementById(root.dataset.configId).textContent);
    wireIntake(root, config, config.kind);
  });
}
initialize(document);
document.addEventListener('shopify:section:load', event => initialize(event.target));
